<template>
    <div class="bbyk">
        <el-card>
            <el-table
                algin=center
                stripe
                size='mini'
                :cell-style="{fontSize:'12px',borderColor:'black'}" 
                :header-cell-style="{fontSize:'12px',background:'#F5F7FA',borderColor:'black'}"
                border
                :data="list"
                show-summary
                @row-click="(row,column,e)=>go(row)">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column 
                    width="140"
                    label="项目公司" 
                    prop="org">
                    <template slot-scope="scope">
                        <span v-if="scope.row.org=='东阳华统牧业有限公司'">东阳华统牧业</span>
                        <span v-if="scope.row.org=='丽水市丽农生态农牧有限公司'">丽水丽农</span>
                        <span v-if="scope.row.org=='丽水市华统食品有限公司'">丽水华统</span>
                        <span v-if="scope.row.org=='丽水市绿生源饲料有限公司'">丽水绿生源</span>
                        <span v-if="scope.row.org=='义乌华农家禽屠宰有限公司'">义乌华农家禽</span>
                        <span v-if="scope.row.org=='义乌华昇牧业有限公司'">义乌华昇</span>
                        <span v-if="scope.row.org=='义乌市绿发农业开发有限公司'">义乌绿发</span>
                        <span v-if="scope.row.org=='乐清市华统牧业有限公司'">乐清华统</span>
                        <span v-if="scope.row.org=='九江浔成肉类联合加工有限公司'">九江浔成</span>
                        <span v-if="scope.row.org=='仙居华统种猪有限公司'">仙居华统</span>
                        <span v-if="scope.row.org=='仙居县广信食品有限公司'">仙居广信</span>
                        <span v-if="scope.row.org=='仙居县绿发饲料有限公司'">仙居绿发饲料</span>
                        <span v-if="scope.row.org=='仙居绿发生态农业有限公司'">仙居绿发生态</span>
                        <span v-if="scope.row.org=='兰溪华统牧业有限公司'">兰溪华统</span>
                        <span v-if="scope.row.org=='兰溪市丽农食品有限公司'">兰溪丽农</span>
                        <span v-if="scope.row.org=='台州华统食品有限公司'">台州华统</span>
                        <span v-if="scope.row.org=='台州市路桥区商业有限公司'">台州路桥</span>
                        <span v-if="scope.row.org=='天台华统牧业有限公司'">天台华统牧业</span>
                        <span v-if="scope.row.org=='天台华统食品有限公司'">天台华统食品</span>
                        <span v-if="scope.row.org=='宁海县华统食品有限公司'">宁海华统</span>

                        <span v-if="scope.row.org=='广州越秀华统食品有限公司'">广州华统</span>

                        <span v-if="scope.row.org=='建德市政新食品有限公司'">建德政新</span>
                        <span v-if="scope.row.org=='杭州临安深山坞里肉类有限公司'">杭州临安</span>
                        <span v-if="scope.row.org=='杭州同壮农业发展有限公司'">杭州同壮</span>
                        <span v-if="scope.row.org=='梨树县华统食品有限公司'">梨树华统</span>
                        <span v-if="scope.row.org=='正康（义乌）猪业有限公司'">正康猪业</span>
                        <span v-if="scope.row.org=='浙江华昇饲料科技有限公司'">华昇饲料科</span>
                        <span v-if="scope.row.org=='浙江华统肉制品股份有限公司'">华统肉制品</span>
                        <span v-if="scope.row.org=='华统股份-养殖事业部'">华统股份-养殖事业部</span>
                        <span v-if="scope.row.org=='华统股份-肉品事业部'">华统股份-肉品事业部</span>
                        <span v-if="scope.row.org=='华统股份-鲜品事业部'">华统股份-鲜品事业部</span>
                        <span v-if="scope.row.org=='华统股份-职能部'">华统股份-职能部</span>
                        <span v-if="scope.row.org=='华统餐饮配送（浙江）有限公司'">华统餐饮配送（浙江）有限公司</span>
                        
                        <span v-if="scope.row.org=='浙江省东阳康优食品有限公司'">东阳康优</span>
                        <span v-if="scope.row.org=='浙江禾壮肥料有限公司'">浙江禾壮</span>
                        <span v-if="scope.row.org=='浙江绿发农牧机械有限公司'">绿发农牧</span>
                        <span v-if="scope.row.org=='浙江绿发饲料科技有限公司'">绿发饲料</span>
                        <span v-if="scope.row.org=='浦江华统牧业有限公司'">浦江华统</span>
                        <span v-if="scope.row.org=='浦江县六和食品有限责任公司'">浦江六和</span>
                        <span v-if="scope.row.org=='海宁市华统食品有限公司'">海宁华统</span>
                        <span v-if="scope.row.org=='湖北华统蕙民食品有限公司'">湖北华统</span>
                        <span v-if="scope.row.org=='湖州南浔华统肉制品有限公司'">湖州南浔</span>
                        <span v-if="scope.row.org=='绩溪县华统食品有限公司'">绩溪华统</span>
                        <span v-if="scope.row.org=='缙云县华昇食品有限责任公司'">缙云华昇</span>
                        <span v-if="scope.row.org=='苍南县华统食品有限公司'">苍南华统</span>
                        <span v-if="scope.row.org=='苏州市华统食品有限公司'">苏州华统</span>
                        <span v-if="scope.row.org=='衢州华统牧业有限公司'">衢州华统</span>
                        <span v-if="scope.row.org=='衢州市民心食品有限公司'">衢州民心</span>
                        <span v-if="scope.row.org=='邵阳市华统食品有限公司'">邵阳华统</span>
                        <span v-if="scope.row.org=='金华市江北畜禽屠宰服务有限公司'">金华江北</span>
                    </template>
                </el-table-column>

                <el-table-column 
                    label="总余额" 
                    prop="ykmoney">
                </el-table-column>
    
            </el-table>
        </el-card>
    </div>
</template>

<script>
import { powerList,ykListAll } from '../router/api';

export default {
    data() {
        return {
            list: [],
            org:[],
            bumen:'',
            you:'',
        };
    },
    
    async mounted() {
        await this.getUser()
        await this.getYk()  
        
    },
    methods: {
        async getUser() {
            await powerList({
                id:'',
                name:'',
                tell: localStorage.getItem('ws_tell'),
            }).then(res => {
                var org  = res.data[0].car.split(',')
                this.you  = res.data[0].you.split(',')
                org.map(item=> {
                    this.org.push(item)
                })
            }).catch(err => {
                console.log(err);
            });
        },
        
        async getYk() {
            await ykListAll({
                id:'',
            }).then(res=> {
                if(res.code==1) {
                    if(this.org[0]=='全部' && this.you[0] == '全部') {
                        this.list = res.data
                    } else {
                        this.list = [];
                        for(var i=0; i< res.data.length; i++ ) {
                            for(var j=0;j<this.org.length; j++) {
                                if(this.org[j] ==  res.data[i].org) {
                                    this.list.push({
                                        org: res.data[i].org, 
                                        ykmoney: res.data[i].ykmoney
                                    })
                                }
                            }
                        }
                    }
                }
            }).catch(err=> {
                console.log(err);
            });
        },
       
        go(row) {
            this.$router.push(`/bbyklist?org=${row.org}`);
        },
       
    },
};
</script>
<style lang="less" scoped>
.bbyk .main {
    display: flex;
    justify-content: space-between;
    span {
        position: relative;
        top: 6px;
        font-size: 12px;
    }
}
.bbyk .el-table {
    border: solid 1px black
}
</style>
